import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "toilet-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_man = _resolveComponent("man")!
  const _component_woman = _resolveComponent("woman")!
  const _component_ambulatory = _resolveComponent("ambulatory")!
  const _component_disability = _resolveComponent("disability")!
  const _component_mixedToilet = _resolveComponent("mixedToilet")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isCorrectIcon(_ctx.types.Men))
      ? (_openBlock(), _createBlock(_component_man, {
          key: 0,
          class: _normalizeClass(_ctx.svgClass)
        }, null, 8, ["class"]))
      : _createCommentVNode("", true),
    (_ctx.isCorrectIcon(_ctx.types.Women))
      ? (_openBlock(), _createBlock(_component_woman, {
          key: 1,
          class: _normalizeClass(_ctx.svgClass)
        }, null, 8, ["class"]))
      : _createCommentVNode("", true),
    (_ctx.isCorrectIcon(_ctx.types.Ambulatory))
      ? (_openBlock(), _createBlock(_component_ambulatory, {
          key: 2,
          class: _normalizeClass(_ctx.svgClass)
        }, null, 8, ["class"]))
      : _createCommentVNode("", true),
    (_ctx.isCorrectIcon(_ctx.types.Disabled))
      ? (_openBlock(), _createBlock(_component_disability, {
          key: 3,
          class: _normalizeClass(_ctx.svgClass)
        }, null, 8, ["class"]))
      : _createCommentVNode("", true),
    (_ctx.isCorrectIcon(_ctx.types.Mixed))
      ? (_openBlock(), _createBlock(_component_mixedToilet, {
          key: 4,
          class: _normalizeClass(_ctx.svgClass)
        }, null, 8, ["class"]))
      : _createCommentVNode("", true)
  ]))
}